import React, { useState, useEffect } from 'react';

export default function AiSparkle({className}) {
    return (
        <span className={`d-flex align-items-center justify-content-center ${className || ''}`}>
            <svg width="0" height="0" style={{position:'absolute'}}>
                <defs>
                    <clipPath id="sparkle-clip" clipPathUnits="objectBoundingBox">
                        <path d="M0.5 0C0.58 0.3 0.7 0.42 1 0.5C0.7 0.58 0.58 0.7 0.5 1C0.42 0.7 0.3 0.58 0 0.5C0.3 0.42 0.42 0.3 0.5 0Z"/>
                    </clipPath>
                </defs>
            </svg>     
            <div className="sparkle" style={{width: '15px', height: '15px', background: '#f32121'}}></div>
            <div className="sparkle" style={{width: '8px', height: '8px', background: '#0059ff', position: 'relative', marginTop:'13px', marginLeft: '-5px'}}></div>
        </span>
    )
}